export enum TransactionReviewField {
    CATEGORY = "category",
    COUNTERPARTY = "counterparty",
    CLASS = "class",
    ENTITY = "entity",
    CASH_LEDGER = "cashLedger",
    ACCRUAL_LEDGER = "accrualLedger",
    NOTE = "note",
}

export const TRANSACTION_REVIEW_FIELD_LABELS: Record<
    TransactionReviewField,
    string
> = {
    [TransactionReviewField.CATEGORY]: "Category",
    [TransactionReviewField.COUNTERPARTY]: "Counterparty",
    [TransactionReviewField.CLASS]: "Class",
    [TransactionReviewField.ENTITY]: "Entity",
    [TransactionReviewField.CASH_LEDGER]: "Cash ledger",
    [TransactionReviewField.ACCRUAL_LEDGER]: "Accrual ledger",
    [TransactionReviewField.NOTE]: "Memo",
};

export function isTransactionReviewField(
    value: string,
): value is TransactionReviewField {
    return value in TRANSACTION_REVIEW_FIELD_LABELS;
}

export function getTransactionReviewFieldLabel(field: string): string {
    return isTransactionReviewField(field)
        ? TRANSACTION_REVIEW_FIELD_LABELS[field]
        : field;
}

export interface FieldReviewFieldValue {
    id: string;
    name: string;
    /** Snapshotted taxonomy for CATEGORY field — drives icon selection. */
    taxonomy?: string;
    /** Snapshotted icon color for CLASS field — drives class icon color. */
    iconColor?: string;
}

export interface FieldReviewMeta {
    reviewedField?: string;
    count?: number;
    indirect?: boolean;
    memberCount?: number;
    memberIds?: number[];
    /** Snapshot of the reviewed field's value at the time of review. Null means the field was empty. */
    fieldValue?: FieldReviewFieldValue | FieldReviewFieldValue[] | null;
}

export function isFieldReviewMeta(value: unknown): value is FieldReviewMeta {
    return value !== null && value !== undefined && typeof value === "object";
}

export interface TransactionFieldReview {
    id: string;
    transactionId: number;
    userId: number;
    field: TransactionReviewField;
    createdAt: Date;
}
